import React from "react";


const Welcome = () => {

    return (

        <section className="header-section">
        <h1>WELCOME TO SHRI S. R. CONVENT SCHOOL !!</h1>
        <p>
          <strong>Shri S. R. Convent School</strong> which is located on Agra Shamshabad road at
           Fatehabad, which will provide highly qualitative education from pre nursery to 
           class XII by well trained and highly educated teachers. This school is established 
           to consider the requirements of the localities of Shamshabad because the Shamshabad
            children facing the problems to come Agra for the education purpose. Shri S.R. Convent  School 
            is one of the premier school of Agra. The school have well equipped science laboratory, 
            library, music & dance class, Horse Riding and also have a large play ground.
        </p>
        <div className="cards">
          <div className="card">
            <img src="https://www.skdschoolagra.com/images/admission.webp" alt="Admission" />
            
          </div>
          <div className="card">
            <img src="https://www.skdschoolagra.com/images/therules.webp" alt="The Rules" />
           
          </div>
          <div className="card">
            <img src="https://www.skdschoolagra.com/images/thefee.webp" alt="School Fees" />
            
          </div>
          <div className="card">
            <img src="https://www.skdschoolagra.com/images/thefee.webp" alt="Photo Gallery" />
            
          </div>
        </div>
      </section>
    )
}

export default Welcome;